<template>
    <div class="job-detail">
        <div class="detail-top">
            <h2>招聘详情<i class="back iconfont icon-fanhui" @click="back"></i></h2>
        </div>
        <div class="detail-info">
            <h1>{{jobInfo.title}}</h1>
            <h6>{{getDate(jobInfo.update_time)}}</h6>
            <div v-html="imgShow(jobInfo.content)"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'JobDetail',
    props:{
        jobInfo:Object
    },
    data () {
        return {
        }
    },
    methods: {
        back () {
            this.$emit('back')
        },
        getDate (time) {
            var  date = new Date(time * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = date.getDate() + ' ';
            return Y+M+D;
        },
        imgShow (str) {
            var reg = new RegExp(/(src=")([^"]*")/g)
            var arr = reg.exec(str)
            if(!arr){
                return str
            }
            else{
                return str.replace(reg,"$1https://guanwang.wsandos.com$2")
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    .job-detail
        width: 100%
        max-width: 1920px
        min-width: 1440px
        margin: 0 auto
        .detail-top
            width: 60%
            margin: 0 auto
            padding: 8% 0 66px
            border-bottom: 1px solid #f5f5f5
            h2
                font-size: 28px
                font-weight: 600
                color: #666
                letter-spacing: 1px
                &:after
                    content: ''
                    display: block
                    width: 72px
                    margin-top: 42px
                    border-bottom: 1px solid #333
                .back
                    text-align: center
                    float: right
                    width: 44px
                    height: 44px
                    line-height: 44px
                    font-size: 20px
                    background: #ededed
                    border-radius: 30px
                    color: #999
                    cursor: pointer
        .detail-info
            width: 60%
            margin: 0 auto
            h1
                font-size: 38px
                text-align: center
                letter-spacing: 1px
                margin: 58px 0 25px
                color: #333
                font-weight: 600
            h6
                font-size: 14px
                text-align: center
                color: #999
                margin-bottom: 78px
            div
                padding-bottom: 190px
            .message
                color: #777
                margin: 5% 0 4%
                font-size: 14px
                line-height: 30px
            .detail-content
                line-height: 30px
                color: #777
                font-size: 14px
                h3
                    font-weight: 600
                    font-size: 22px
                    margin-bottom: 2%
                    color: #000
                ol
                    margin-left: 1.2em
                    margin-bottom: 4em
                    li
                        list-style: decimal
</style>


// WEBPACK FOOTER //
// src/components/pc/JobDetail.vue